// Turbolinks shims
import {setup as setupTurbolinksFacebookSDK} from '../src/shims/turbolinks-facebook-sdk';
import {setup as setupTurbolinksReload} from '../src/shims/turbolinks-reload';

// Component manager
import {initialize as initializeAppComponents} from '../src/app/app-component-manager';
import {initialize as initializeAvatarBuilderComponents} from '../src/app/avatar-builder-component-manager';
import {initialize as initializeConversationComponents} from '../src/app/conversation-component-manager';
import {initialize as initializeFormComponents} from '../src/app/form-component-manager';
import {initialize as initializeGroupComponents} from '../src/app/group-component-manager';
import {initialize as initializeMenteeComponents} from '../src/app/mentee-component-manager';
import {initialize as initializeMentorComponents} from '../src/app/mentor-component-manager';
import {initialize as initializeOrganizationComponents} from '../src/app/organization-component-manager';
import {initialize as initializeTeacherComponents} from '../src/app/teacher-component-manager';

// Make sure that the tracker doesn’t start before
// configuring it when the DOM is ready.
if (window.ahoy) window.ahoy.configure({startOnReady: false});

setupTurbolinksFacebookSDK();
setupTurbolinksReload();

initializeAppComponents();
initializeAvatarBuilderComponents();
initializeConversationComponents();
initializeFormComponents();
initializeGroupComponents();
initializeMenteeComponents();
initializeMentorComponents();
initializeOrganizationComponents();
initializeTeacherComponents();

const appId = window.Academos?.OneSignalAppId ?? null;
const oneSignalUser = window.Academos?.OneSignalExternalUser ?? null;

if (appId !== null && oneSignalUser !== null) {
  window.OneSignal.push(async () => {
    await window.OneSignal.init({
      appId,
      requiresUserPrivacyConsent: true,
    });
    await window.OneSignal.provideUserConsent(true);
    await window.OneSignal.setEmail(oneSignalUser.email);
    await window.OneSignal.setExternalUserId(oneSignalUser.externalId);
  });
}

const appVersion = window.Academos.appVersion;
window.console.log(`App v${appVersion}`);
